import StaticPerimeter from './StaticPerimeter'

export default StaticPerimeter
